/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum GlAccountTypeId {
  BalanceSheet = 1,
  ProfitAndLoss = 2,
}
